package com.neurobs.react

import slinky.core.{ComponentWrapper, FunctionalComponent}
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html.{div, key, onClick, style, table, tbody, td, tr}

import scala.scalajs.js

trait ListBoxItem {
	def content(): Seq[ReactElement]
	def equal(rhs: ListBoxItem): Boolean
	def select(): Unit
	def key(): String
}

@react
object ListBox {

	case class Props(options: Seq[ListBoxItem], selection: Option[ListBoxItem])

	val component = FunctionalComponent[Props] { props =>
		val tstyle = StyleUtil.makeStyle(
			("display", "block"),
			("overflowY", "auto"),
			("height", "300px"),
			("backgroundColor", "LightBlue"),
			("borderSpacing", "5px"),
			("borderCollapse", "separate")
		)
		table(style := tstyle)(tbody(props.options.map { item =>

			val selected = props.selection.exists(_.equal(item))
			def rowStyle = StyleUtil.makeStyle(
				("backgroundColor", if (selected) "coral" else "white"),
				("color", "black"),
				("width", "100%"),
				("padding", "5px"),
				("cursor", "pointer")
			)
			tr(key := item.key())(
				td(
					style := rowStyle,
					onClick := {() => item.select()}
				)(
					item.content()
				)
			)
		}))
	}
}